window.EMBFabricMap = {

  "gingham-pink":
    "/cdn/shop/files/gingham-pink.png",

  "gingham-red":
    "/cdn/shop/files/gingham-red.png",

  "gingham-blue":
    "/cdn/shop/files/gingham-blue.png",

  "burlap":
    "/cdn/shop/files/burlap.png",

  "leopard":
    "/cdn/shop/files/leopard.png",

  "cheetah":
    "/cdn/shop/files/cheetah.png"

};